import cn from 'classnames';

import { Restricted } from 'containers/Restricted';

import { OrgLink } from 'components/ui/atoms/OrgLink';

import type { SidebarMenuItem } from './SidebarItem';

interface SidebarSingleItemProps {
  item: SidebarMenuItem;
  isActive: boolean;
  sidebarOpen: boolean;
  'data-testid'?: string;
}

export const SidebarSingleItem = ({
  item,
  isActive,
  sidebarOpen,
  'data-testid': dataTestId
}: SidebarSingleItemProps) => {
  const Icon = item.icon;

  return (
    <Restricted requiredPermission={item.requiredPermission}>
      <OrgLink
        id={item.id}
        to={item.path}
        title={item.title}
        aria-label={item.title}
        aria-current={isActive ? 'page' : undefined}
        className={cn(
          'flex h-11 items-center rounded-full px-3 text-sm font-medium',
          {
            'gap-3': sidebarOpen,
            'justify-center px-0': !sidebarOpen,
            'bg-surface-selected': isActive,
            'hover:bg-gray-100': !isActive
          }
        )}
        data-testid={dataTestId}
      >
        <Icon
          className={cn('size-5 shrink-0', {
            'stroke-content-brand': isActive
          })}
        />
        {sidebarOpen ? (
          <span
            className={cn('whitespace-nowrap font-normal text-black', {
              'text-content-brand': isActive
            })}
          >
            {item.title}
          </span>
        ) : (
          <span className="sr-only">{item.title}</span>
        )}
      </OrgLink>
    </Restricted>
  );
};
